import { render } from "./AppsConfigPanel.vue.js?vue&type=template&id=33a264dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppsConfigPanel.vue?vue&type=template&id=33a264dc"
import script from "./AppsConfigPanel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppsConfigPanel.vue?vue&type=script&lang=js"
export * from "./AppsConfigPanel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppsConfigPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/create-dashboard/AppsConfigPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33a264dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33a264dc', __exports__)) {
    api.reload('33a264dc', __exports__)
  }
  
  module.hot.accept("./AppsConfigPanel.vue.js?vue&type=template&id=33a264dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppsConfigPanel.vue?vue&type=template&id=33a264dc", () => {
    api.rerender('33a264dc', render)
  })

}


export default __exports__